import axios, { REFRESH_TOKEN_URL } from "../../../Api/axios";
import useAuth from "../useAuth/useAuth";
import {useNavigate} from "react-router-dom";
import {logout} from "../../Logout/Logout";

const useRefreshToken = () => {
    const { auth, setAuth, setLoggedIn } = useAuth();
    const navigate = useNavigate();
    const refreshToken = auth?.refreshToken

    const refresh = async () => {
        try {
            const response = await axios.post(REFRESH_TOKEN_URL,  refreshToken, {
                headers: {'Content-Type' : 'text/plain;charset=UTF-8',
                    'Accept' : '*/*'}
            });
            setAuth(prev => {
                console.log(JSON.stringify(prev));
                console.log(response.data.accessToken);
                return {...prev, accessToken: response.data.accessToken}
            });
            return response.data.accessToken;
        } catch (err) {
            logout(setLoggedIn, navigate);
            console.error(err);
        }
    }
    return refresh;
};
export default useRefreshToken;